import { Box, Text } from "@chakra-ui/react"
import { FC } from "react"

interface ValidationIndicatorProps {
  isValid: boolean
}

const ValidationIndicator: FC<ValidationIndicatorProps> = ({ isValid }) => {
  return (
    <Box textAlign={"center"} w={"100%"} bg={isValid ? "blue.500" : "red.500"} borderRadius={"md"} my={2} p={2}>
      <Text fontWeight={"bold"}>{isValid ? "Is valid" : "Invalid Input"}</Text>
    </Box>
  )
}

export default ValidationIndicator
